import React from 'react'

import {
  Image as ImageComponent,
  type ImageProps as ImagePropsType,
} from '@components/Image'
import SafeHTML from '@components/SafeHTML'

interface ImageProps {
  image: ImagePropsType
  zoomable: boolean
  caption: string
  alt: string
  width: number
  height: number
}

const Image = ({
  image,
  zoomable,
  caption,
  alt,
  width,
  height,
}: ImageProps) => {
  return (
    <figure className="h-full">
      <ImageComponent
        className={`${width < 200 ? `w-[${width}px] h-[${height}px]` : 'aspect-video'}`}
        {...image}
        zoomable={zoomable}
        alt={alt}
      />
      {caption && (
        <figcaption className="text-sm text-[#666666] mt-3">
          <SafeHTML html={caption} />
        </figcaption>
      )}
    </figure>
  )
}

export default Image
